import React, { createContext, useState } from "react";
import { DEFAULT_FILTERS } from "../../../constants/perfectStoreConstants";

export const DropdownContext = createContext({
  selectedValue: "mtd",
  setSelectedValue: () => {},
  selectedView: null,
  setSelectedView: () => {},
  activeTab: "team",
  setActiveTab: () => {},
  isPerfectStoreTab: false,
  setIsPerfectStoreTab: () => {},
  perfectStoreFilters: DEFAULT_FILTERS,
  setPerfectStoreFilters: () => {},
});

export const DropdownProvider = ({ children }) => {
  const [selectedValue, setSelectedValue] = useState("mtd");
  const [selectedView, setSelectedView] = useState(null);
  const [activeTab, setActiveTab] = useState("team");
  const [isPerfectStoreTab, setIsPerfectStoreTab] = useState(false);
  const [perfectStoreFilters, setPerfectStoreFilters] = useState(DEFAULT_FILTERS);

  return (
    <DropdownContext.Provider value={{ selectedValue, setSelectedValue, selectedView, setSelectedView, activeTab, setActiveTab, isPerfectStoreTab, setIsPerfectStoreTab, perfectStoreFilters, setPerfectStoreFilters }}>
      {children}
    </DropdownContext.Provider>
  );
};
